module.exports = __webpack_public_path__ + "img/hero-bg.c6193039.png";